import SFApi from './_sfApi';
import httpClient from '@/apis/base/httpclient';

class voucherSearchAPI extends SFApi {
  constructor() {
    super();
  }
  controllerName = 'SearchFields';

  /**
   * Hàm lấy dữ liệu khi chọn trường tương ứng của trường cần lọc
   * @param {*} records
   * @returns
   * dqvinh 4.11.2022
   */
  async getDataDependencies(item, payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getDataDependencies',
      data: { item: item, payload: payload },
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Hàm cập nhật trạng thái về 0 để chạy lại đồng bộ tìm kiếm
   * @returns 
   * dqvinh 12.12.2023
   */
  async updateStatus(status = 0){
    let request = {
      url: this.getAPIUrl() + `/updateStatus/${status}`
    };

    return httpClient.getAsync(request);
  }

}

export default new voucherSearchAPI();
